// eslint-disable-next-line import/no-anonymous-default-export
export default {
    screens: [
      {
        observation: "si_intro",
        type: "intro",
        module: "self_perception",
        meta: {
          v2: true,
          hiddenHeader: true,
          hideBottumNavigation: true,
          image: "self_imgs/intro_selfimage",
        },
        auto_advance: true,
        timer: {
          time: 10000,
          extend: false,
          pause: false,
          visible: false,
        },
      },
      {
        observation: "lifesatisfaction1",
        module: "self_perception",
        type: "find_pattern",
        help: true,
        auto_advance: true,
        timer: {
          time: 15000,
          extend: true,
          pause: false,
          visible: true,
        },
        meta: {
          valueVisible: false,
          hideBottumNavigation: true,
          v2: true,
          variant: false,
          hideHalpNavigation: true,
          helpImgs: ["self_imgs/lifesatisfaction1help1"],
          title: { alignment: "center" },
          options: [
            {
              img: "self_imgs/conscientiousness_highachievingImg1",
              label: "Very Satisfied",
            },
            {
              img: "self_imgs/conscientiousness_highachievingImg2",
              label: "Satisfied",
            },
            {
              img: "self_imgs/conscientiousness_highachievingImg3",
              label: "Neutral",
            },
            {
              img: "self_imgs/conscientiousness_highachievingImg4",
              label: "Unsatisfied",
            },
            {
              img: "self_imgs/conscientiousness_highachievingImg5",
              label: "Very Unsatisfied",
            },
          ],
          "optionValue": [
            {
              "label": "Very Satisfied"
            },
            {
              "label": "Satisfied"
            },
            {
              "label": "Neutral"
            },
            {
              "label": "Unsatisfied"
            },
            {
              "label": "Very Unsatisfied"
            }
          ]
        },
      },
      {
        observation: "honesty2",
        module: "self_perception",
        type: "pick_img",
        help: true,
        auto_advance: true,
        timer: {
          time: 15000,
          extend: true,
          pause: false,
          visible: true,
        },
        meta: {
          generate: {
            delay: 14999,
          },
          hideBottumNavigation: true,
          hideHalpNavigation: true,
          title: {
            alignment: "left",
          },
          valueVisible: true,
          option: [
            "self_imgs/honesty2Img1",
            "self_imgs/honesty2Img2",
            "self_imgs/honesty2Img3",
            "self_imgs/honesty2Img4",
            "self_imgs/honesty2Img5",
            "self_imgs/honesty2Img6",
          ],
        },
      },
      {
        observation: "financialsituation3",
        type: "group_image_button",
        module: "self_perception",
        timer: {
          time: 15000,
          extend: true,
          pause: false,
          visible: true,
        },
        auto_advance: true,
        help: true,
        meta: {
          title: {
            alignment: "left",
            text: "What do you use your phone for?  (Select all that apply)",
          },
          generate: {
            delay: 14999,
          },
          center: true,
          hideHalpNavigation: true,
          valueVisible: true,
          helpImgs: ["self_imgs/financialsituation3help1"],
          options: [
            { image: "self_imgs/financialsituation3Img1", label: "Call" },
            { image: "self_imgs/financialsituation3Img2", label: "Whatsapp" },
            { image: "self_imgs/financialsituation3Img3", label: "Picture" },
            { image: "self_imgs/financialsituation3Img4", label: "Social media" },
            { image: "self_imgs/financialsituation3Img5", label: "Email" },
            { image: "self_imgs/financialsituation3Img6", label: "Google" },
            { image: "self_imgs/financialsituation3Img7", label: "Health apps" },
            {
              image: "self_imgs/financialsituation3Img8",
              label: "Financial apps",
            },
            { image: "self_imgs/financialsituation3Img9", label: "Games" },
          ],
        },
        next: {
          rules: {
            visible: true,
            enabled: ["itsDone"],
          },
          visible: true,
          enabled: false,
        },
      },
      {
        observation: "optimism1",
        type: "simple_slider",
        module: "self_perception",
        help: true,
        meta: {
          min: 1,
          max: 100,
          marks: {},
          defaultValue: 50,
          options: [{}, {}, {}],
          center: true,
        },
        auto_advance: true,
        timer: {
          time: 15000,
          extend: true,
          pause: false,
          visible: true,
        },
        next: {
          rules: {
            visible: true,
            enabled: ["observation"],
          },
          // valueVisible: true,
          visible: true,
          enabled: false,
        },
      },
      {
        type: "radio_group",
        observation: "extraversion3",
        module: "self_perception",
        meta: {
          title: {
            alignment: "left",
          },
          center: true,
          options: [
            {
              value: 1,
            },
            {
              value: 2,
            },
            {
              value: 3,
            },
            {
              value: 4,
            },
            {
              value: 5,
            },
          ],
          shuffle: false
        },
        help: true,
        next: {
          rules: {
            visible: true,
            enabled: ["observation"],
          },
          visible: true,
          enabled: false,
        },
        auto_advance: true,
        timer: {
          time: 15000,
          extend: true,
          pause: false,
          visible: true,
        }
      },
      {
        observation: "honesty3",
        module: "self_perception",
        type: "hover_slider",
        help: true,
        auto_advance: true,
        meta: {
          title: { alignment: "left" },
          maxImgs: Array.from({ length: 10 }, () => false),
          helpImgs: "self_imgs/honesty3help1",
          hideHalpNavigation: true,
        },
        timer: {
          time: 15000,
          extend: true,
          pause: false,
          visible: true,
        },
        next: {
          rules: {
            visible: true,
            enabled: ["observation"],
          },
          visible: true,
          enabled: false,
        },
      },
      {
        observation: "locusofcontrol1",
        module: "self_perception",
        type: "pick_img",
        help: true,
        auto_advance: true,
        timer: {
          time: 15000,
          extend: true,
          pause: false,
          visible: true,
        },
        meta: {
          hideHalpNavigation: true,
          generate: {
            delay: 14999,
          },
          hideBottumNavigation: true,
          title: {
            alignment: "left",
          },
          valueVisible: true,
          option: [
            "self_imgs/locusofcontrol1Img1",
            "self_imgs/locusofcontrol1Img2",
            "self_imgs/locusofcontrol1Img3",
            "self_imgs/locusofcontrol1Img4",
            "self_imgs/locusofcontrol1Img5",
            "self_imgs/locusofcontrol1Img6",
          ],
          optionValue: [
            "Hard Work",
            "Rich family",
            "Network",
            "Cheating",
            "Luck",
            "Intelligence",
          ],
        },
      },
      {
        observation: 'rotation_page',
        module: 'self_perception',
        type: 'radio_group',
        help: true,
        auto_advance: true,
        meta: {
          image: 'rotation_puzzle',
          center: true,
          title: {
            alignment: 'left'
          },
          options: [{
            value: 1
          }, {
            value: 2
          },
          {
            value: 3
          }],
        },
        timer: {
          time: 15000,
          extend: true,
          pause: false,
          visible: true,
        },
        next: {
          rules: {
            visible: true,
            enabled: ['observation']
          },
          visible: true,
          enabled: false
        },
      },  
      {
        observation: "greatJob",
        type: "module_finish",
        module: "self_perception",
        auto_advance: true,
        next: {
          visible: true,
          enabled: true
        },
        timer: {
          time: 3000,
          extend: false,
          pause: false,
          visible: false,
        },
      },
    ],
    screen_submit: false,
    session_store: true
  };
  